import React, { useState, useEffect } from "react";
import Select from "../components/common/Select";
import { Button } from "@material-ui/core";
import Grid from "@mui/material/Grid";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useSelector, useDispatch } from "react-redux";
import { deviceFun, groupFun } from "../components/redux/reducer";

const columns = [
  { id: "pid", label: "PID" },
  { id: "device", label: "Device" },
  { id: "alertName", label: "Alertname" },
  { id: "triggeredTime", label: "Triggered Time(UTC)" },
  { id: "triggeredValue", label: "Triggered Value" },
  { id: "state", label: "State" },
];
const Alert = (props) => {
  const device = useSelector((state) => state.filter.device);
  const group = useSelector((state) => state.filter.group);
  const dispatch = useDispatch();
  const [groupList, setGroupList] = useState([]);
  const [groupFilter, setGroupFilter] = useState(null);
  const [devicesList, setDevicesList] = useState([]);
  const [nameErr, setNameErr] = useState(false);
  const [alertList, setAlertList] = useState([]);
  const [deviceFilter, setDeviceFilter] = useState(null);
  const [alertData, setAlertData] = useState({
    alertName: "",
    process: "",
    percentage: "",
    groupName: "",
    deviceName: "",
  });
  const [modal, setModal] = useState(false);

  useEffect(() => {
    props.headerName("Alert");
  }, []);

  useEffect(() => {
    setDeviceFilter(device);
    setGroupFilter(group);
  }, [group, device]);

  const modalContent = () => {
    return (
      <>
        <div
          style={{
            backgroundColor: "#075a6a",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            padding: "20px",
            color: "#c1d8dd",
          }}
        >
          <span>Create Alert</span>
          <span
            onClick={() => {
              setModal(false);
            }}
            style={{ float: "right", cursor: "pointer" }}
          >
            X
          </span>
        </div>
        <div>
          <Grid
            container
            spacing={1}
            style={{
              width: "100%",
              margin: "0px",
              padding: "5px 30px 20px 10px",
            }}
          >
            <Grid item xs={12} md={12}>
              <Grid>
                <div>
                  <h4
                    style={{
                      color: "#075a6a",
                      marginBottom: "5px",
                      marginTop: "10px",
                    }}
                  >
                    Alert Name*
                  </h4>
                  <Grid item xs={12} md={12}>
                    <TextField
                      name="name"
                      className={
                        nameErr ? "createGroupFieldsError" : "createGroupFields"
                      }
                      onChange={(e) => {
                        setAlertData({
                          ...alertData,
                          alertName: e.target.value,
                        });
                      }}
                      color="primary"
                      required
                      fullWidth
                      style={{ borderRadius: "12px" }}
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Grid>
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
              <h4
                style={{
                  color: "#075a6a",
                  marginBottom: "5px",
                  marginTop: "10px",
                }}
              >
                Triggered When*
              </h4>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Select
                    list={[{ name: "Controller Id", value: "controllerId" }]}
                    name={"Process"}
                    onChange={(e) => {
                      setAlertData({ ...alertData, process: e });
                    }}
                    style={{
                      borderRadius: "12px",
                      padding: "10px",
                      marginTop: "0px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  ></Select>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Select
                    list={[{ name: "less Then", value: "less Then" }]}
                    name={"Equal to"}
                    onChange={(e) => {}}
                    style={{
                      borderRadius: "12px",
                      padding: "10px",
                      marginTop: "0px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  ></Select>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="percentage"
                    fullWidth
                    className="createGroupFields"
                    onChange={(e) => {
                      setAlertData({
                        ...alertData,
                        percentage: e.target.value,
                      });
                    }}
                    color="primary"
                    style={{ borderRadius: "12px" }}
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
              <h4
                style={{
                  color: "#075a6a",
                  marginBottom: "5px",
                  marginTop: "10px",
                }}
              >
                Select Device*
              </h4>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Select
                    list={[{ name: "Group 1", value: "Group 1" }]}
                    name={"Choose Group"}
                    onChange={(e) => {
                      setAlertData({ ...alertData, groupName: e });
                    }}
                    style={{
                      borderRadius: "12px",
                      padding: "10px",
                      marginTop: "0px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  ></Select>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Select
                    list={[{ name: "Device 1", value: "Device 1" }]}
                    name={"Choose Device"}
                    onChange={(e) => {
                      setAlertData({ ...alertData, deviceName: e });
                    }}
                    style={{
                      borderRadius: "12px",
                      padding: "10px",
                      marginTop: "0px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  ></Select>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <hr style={{ margin: "0px 25px 25px" }} />
        <div className="footer">
          <Button
            variant="contained"
            style={{
              textTransform: "none",
              backgroundColor: "#0fcbd0",
              color: "white",
              borderRadius: "10px",
              margin: "10px",
            }}
            onClick={() => {
              console.log(alertData);
            }}
          >
            Save
          </Button>
          <Button
            variant="contained"
            style={{
              textTransform: "none",
              backgroundColor: "#075a6a",
              color: "white",
              borderRadius: "10px",
              margin: "10px",
            }}
            onClick={() => {
              setModal(false);
            }}
          >
            Close
          </Button>
        </div>
      </>
    );
  };

  const modalFun = () => {
    return (
      <Modal
        disableEnforceFocus={true}
        open={modal ? true : false}
        onClose={(e, reason) => {
          if (reason != "backdropClick") {
            setModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="createGroup" style={{ p: 4, width: "40%" }}>
          {modalContent()}
        </Box>
      </Modal>
    );
  };

  return (
    <div>
      <div
        style={{
          backgroundColor: "#effafb",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            fotntWeight: "bold",
            marginRight: "20px",
            margin: "10px",
            fontSize: ".8rem",
            paddingLeft: "30px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Filter Device
        </div>
        <div>
          <Select
            list={groupList}
            value={groupFilter}
            name={"Choose Group"}
            onChange={(e) => {
              setGroupFilter(e);
            }}
          />
        </div>
        <div>
          <Select
            list={devicesList}
            name={"Choose Device"}
            value={deviceFilter}
            onChange={(e) => {
              setDeviceFilter(e);
            }}
          />
        </div>
        <div
          style={{
            fotntWeight: "bold",
            marginRight: "20px",
            width: "100px",
            marginTop: "-5px",
            margin: "10px",
          }}
        >
          <Button
            variant="contained"
            style={{
              textTransform: "none",
              backgroundColor: "#0fcbd0",
              color: "white",
              borderRadius: "10px",
              height: "25px",
            }}
            onClick={() => {
              dispatch(deviceFun(deviceFilter));
              dispatch(groupFun(groupFilter));
            }}
          >
            Apply
          </Button>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            color: "rgb(8, 94, 111)",
            marginLeft: "50px",
            marginTop: "20px",
            fontSize: "20px",
          }}
          className="tr-hide-mobile"
        >
          Alert List
        </div>
        <div style={{ marginLeft: "auto", display: "flex" }}>
          <Grid item xs={12} md={6}>
            <div
              onClick={() => {
                setModal(true);
              }}
              style={{
                backgroundColor: "rgb(8, 94, 111)",
                borderRadius: "15px",
                padding: "5px 10px 5px 10px",
                color: "white",
                cursor: "pointer",
                width: "120px",
                marginTop: "20px",
                marginRight: "50px",
              }}
            >
              <AddCircleOutlineIcon
                style={{ paddingTop: "3px", fontSize: "20px" }}
              />{" "}
              <span
                style={{
                  position: "relative",
                  top: "-5px",
                  fontSize: "12px",
                }}
              >
                Create Alert
              </span>
            </div>
          </Grid>
        </div>
      </div>
      <Paper
        sx={{
          width: "93%",
          overflow: "hidden",
          marginLeft: "50px",
          marginTop: "20px",
        }}
      >
        <TableContainer sx={{ maxHeight: 575 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow key="head">
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontWeight: 900 }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {alertList.map((row) => {
                return (
                  <TableRow tabIndex={-1} key={row.id}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {modal && modalFun()}
    </div>
  );
};

export default Alert;
